import React from 'react'
import Hero from '../components/Hero'
import Team from '../components/Team'
import ContactUs from '../components/ContactUs'
import EmailFooter from '../components/EmailFooter'
import { Layout } from '../components/styles'
import WhySaatchi from '../components/WhySaatchi'
import Services from '../components/Landing/Services'
import Benefit from '../components/Landing/Benefit'
import Process from '../components/Landing/Process'
import EmergingArtists from '../components/Landing/EmergingArtists'
import CaseStudyCarousel from '../components/Landing/CaseStudyCarousel'
import ClientCarousel from '../components/Landing/ClientCarousel'
type Props = {
  section: string
}

const Component = ({
  section,
}: Props): React.ReactElement<React.ComponentProps<any>, any> | null => {
  return (
    <Layout data-layout='landing'>
      <Hero section={section} />
      <WhySaatchi section={section} />
      <Services section={section} />
      <Benefit />
      <Process />
      <EmergingArtists />
      <CaseStudyCarousel />
      <ClientCarousel />
      <Team showCase />
      <EmailFooter />
      <ContactUs />
    </Layout>
  )
}

export default Component
